export default __webpack_public_path__ + "static/media/04.424eba39.jpg";